import { render, staticRenderFns } from "./ListTransition.vue?vue&type=template&id=425fe5c9&"
import script from "./ListTransition.vue?vue&type=script&lang=ts&"
export * from "./ListTransition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports